import { JSX } from "react";
import { AlertContextProvider, GlobalAlert } from "./AlertContextProvider";
import { GlobalProgressDialog, ProgressContextProvider } from "./ProgressContextProvider";

export type T_ContextsProps = {
    children: JSX.Element;
  };
  
  function Contexts({ children }: T_ContextsProps) {
    return (
        <ProgressContextProvider>
        <GlobalProgressDialog />
          <AlertContextProvider>
            <GlobalAlert />
            {children}
            </AlertContextProvider>
        </ProgressContextProvider>
    );
  }
  
  export default Contexts;
  